<template>
  <div>
    <button
      :class="['but fn-12', className, { 'download-icon': showDownloadIcon }]"
      v-if="!loading"
      @click="submitCallback"
      :type="type"
      :disabled="disableBtn"
    >
      <DownloadIcon v-if="showDownloadIcon" width="14" height="14" />
      {{ text }}
      <Icon v-if="showIcon" width="18" height="14" />
    </button>
    <button v-else-if="newLoader" class="loader-btn">
      <Spinner />
    </button>
    <Spinner v-else />
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'
import icon from '@/assets/icons/svg/right-arrow.svg'
import downloadIcon from '@/assets/icons/svg/download.svg'

export default {
  name: 'V-Button',
  props: [
    'callback',
    'text',
    'loading',
    'className',
    'type',
    'disableBtn',
    'showIcon',
    'showDownloadIcon',
    'newLoader'
  ],
  data: function() {
    return {}
  },
  components: {
    Spinner,
    Icon: icon,
    DownloadIcon: downloadIcon
  },
  methods: {
    submitCallback() {
      this.callback()
    }
  }
}
</script>

<style lang="scss">
.download-icon {
  svg {
    fill: $white;
    margin-right: 4px;
  }
}
.loader-btn {
  border: 0;
  border-radius: 4px;
  background: $primary-color;
  width: 100%;
  padding: 10px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner > div {
    background-color: #fff;
  }
}
</style>
